const initialState = () => ({
  assigned_templates: [], // plantillas asignadas al usuario
  have_assigned_templates: false, // el usuario tiene plantillas asignadas
})

export default initialState
